import { render, staticRenderFns } from "./CenteredForm.vue?vue&type=template&id=1b68e269&scoped=true&"
import script from "./CenteredForm.vue?vue&type=script&lang=js&"
export * from "./CenteredForm.vue?vue&type=script&lang=js&"
import style0 from "./CenteredForm.vue?vue&type=style&index=0&id=1b68e269&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b68e269",
  null
  
)

export default component.exports